export class CyclicList<T> {
    private values: T[];
    private index: number = 0;

    constructor(values: T[]) {
        if (!values || values.length === 0) {
            throw new Error('Values list must not be empty');
        }
        this.values = values;
    }

    next(): T {
        const value = this.values[this.index];
        this.index = (this.index + 1) % this.values.length;
        return value;
    }
}